// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__2HjYG","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__34uY5"};